/// <amd-module name="TFS/Token/PatTokenPage/Components/Panels/TokenPanelContainer" />
import { PanelActionCreator, PanelOperationType } from 'Actions/PanelActionCreator';
import { TokenActionCreator } from 'Actions/TokenActionCreator';
import { AddOrEditTokenPanel } from 'Components/Panels/Panel.AddOrEdit';
import { ConfirmRevokeOrRegeneratePanel } from 'Components/Panels/Panel.ConfirmRevokeOrRegenerate';
import SuccessPanel from 'Components/Panels/Panel.Success';
import { AccountNameConsumer, IAccountNameContextValue } from 'Context/AccountNameContext';
import { IPanelContextValue, PanelConsumer } from 'Context/PanelContext';
import { IPatPageContextValue, PatPageConsumer } from 'Context/PatPageContext';
import { Token } from 'Models/Token';
import * as React from 'react';
import { IPanelProps } from "VSSUI/Panel";

export interface ITokenPanelContainerProps {
}

export interface ITokenPanelContainerInternalProps extends ITokenPanelContainerProps {
    panelContext: IPanelContextValue,
    panelAction: PanelActionCreator,
    tokenAction: TokenActionCreator,
    accountNameContext: IAccountNameContextValue,
}

export interface ITokenPanelContainerState {
    createdToken?: Token
}

class TokenPanelContainerInternal extends React.Component<ITokenPanelContainerInternalProps, ITokenPanelContainerState> {
    constructor(props: ITokenPanelContainerInternalProps) {
        super(props);
    }

    public render() {
        const {
            token,
            operation,
        } = this.props.panelContext;
        const {
            addToken,
            revokeToken,
            updateToken
        } = this.props.tokenAction;
        const {
            accounts,
            accountIdToNameMap,
        } = this.props.accountNameContext;
        const {
            openTokenPanel
        } = this.props.panelAction;
        const baseProps: Pick<IPanelProps, "onDismiss"> = {
            onDismiss: () => {
                if (operation !== undefined) {
                    this.props.panelAction.closeTokenPanel(operation)
                }
            },
        };
        return <>
            {token && operation !== undefined && (operation === PanelOperationType.ConfirmRevoke || operation === PanelOperationType.ConfirmRegenerate) &&
                <ConfirmRevokeOrRegeneratePanel
                    {...baseProps}
                    operation={operation}
                    token={token}
                    revokeToken={revokeToken}
                    addToken={addToken}
                />}
            {token && operation === PanelOperationType.Success &&
                <SuccessPanel
                    {...baseProps}
                    token={token}
                />}
            {(operation === PanelOperationType.Add || operation === PanelOperationType.Edit) &&
                <AddOrEditTokenPanel
                    {...baseProps}
                    accounts={accounts}
                    accountIdToNameMap={accountIdToNameMap}
                    token={token}
                    addToken={addToken}
                    updateToken={updateToken}
                />}
        </>
    }
}


export const TokenPanelContainer = (props: ITokenPanelContainerProps) =>
    <PatPageConsumer>
        {(patPageContext: IPatPageContextValue) =>
            <PanelConsumer>
                {(panelContext: IPanelContextValue) =>
                    <AccountNameConsumer>
                        {(accountNameContext: IAccountNameContextValue) =>
                            <TokenPanelContainerInternal
                                panelContext={panelContext}
                                accountNameContext={accountNameContext}
                                panelAction={PanelActionCreator.getInstance()}
                                tokenAction={TokenActionCreator.getInstance(patPageContext.pageContext)}
                            />}
                    </AccountNameConsumer>}
            </PanelConsumer>}
    </PatPageConsumer>;

